export default {
  data() {
    return {
      inputJson: `{
            "id": "24208",
            "name_en": "压图",
            "name_zh": "压图-logo",
            "real_name": "小豆包",
            "country_name": "小豆包logo"
      }`,
      outputJson: '',
      copyOutputJson: ''
    };
  },
  methods: {
    formatJson() {
      try {
        const parsedData = JSON.parse(this.inputJson);
        this.copyOutputJson = parsedData;
        const copy = JSON.parse(this.copyOutputJson);
        const jstr = JSON.stringify(copy, null, 6);
        this.outputJson = jstr;
      } catch (error) {
        this.outputJson = '无效的 JSON 数据: ' + error.message;
      }
    },
    formatString() {
      try {
        const parsedData = JSON.stringify(this.inputJson);

        // this.copyOutputJson = parsedData
        // const copy = JSON.parse(this.copyOutputJson)
        // const jstr = JSON.stringify(parsedData)
        this.outputJson = parsedData;
      } catch (error) {
        this.outputJson = '无效的 JSON 数据: ' + error.message;
      }
    },
    copyToClipboard() {
      if (this.outputJson) {
        navigator.clipboard.writeText(this.outputJson).then(() => {
          this.$message.success('复制成功！');
        }).catch(err => {
          this.$message.error('复制失败: ' + err);
        });
      }
    }
  }
};